import { AnchorHTMLAttributes, DetailedHTMLProps } from 'react';

import styles from '@components/typography/InternalLink.module.css';

type AnchorProps = DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;
type Props = Omit<AnchorProps, 'rel' | 'tabIndex' | 'target'> &
  Required<Pick<AnchorProps, 'href'>> & {
    expand?: boolean;
    stylized?: boolean;
  };

const ExternalLink = ({ className, expand = false, stylized = true, ...anchorProps }: Props) => {
  const classNames = [styles.reset];
  if (expand) {
    classNames.push(styles.expand);
  }
  if (stylized) {
    classNames.push(styles.stylized);
  }
  if (className) {
    classNames.push(className);
  }

  return <a {...anchorProps} className={classNames.join(' ')} rel="noopener noreferrer" target="_blank" />;
};

export default ExternalLink;
